import { useEffect, useState } from 'react';

const TopRankedHero = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-[420px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/761d8907959c94bf295b1d997003030c.jpg"
          alt="Top Ranked Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-[#0a0a0a]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-black/40" />
      </div>

      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-red-500/40 rounded-full"
            style={{
              left: `${10 + i * 12}%`,
              top: `${20 + (i % 3) * 25}%`,
              animation: `float ${3 + i * 0.5}s ease-in-out infinite alternate`,
              animationDelay: `${i * 0.3}s`,
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto pt-24 pb-12">
        {/* Crown icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 flex items-center justify-center bg-red-600/20 border border-red-600/40 rounded-full backdrop-blur-sm">
            <i className="ri-trophy-line text-3xl text-red-500" />
          </div>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-white font-['Cinzel'] mb-4 tracking-wide">
          Top <span className="text-red-600">Ranked</span>
        </h1>
        <p className="text-gray-300 text-lg md:text-xl font-['Crimson_Text'] max-w-2xl mx-auto leading-relaxed">
          The most terrifying, most-loved, and most-read stories chosen by our community of horror enthusiasts.
        </p>

        {/* Stats bar */}
        <div className="flex items-center justify-center gap-8 mt-8">
          {[
            { icon: 'ri-heart-fill', label: 'Most Liked', color: 'text-red-500' },
            { icon: 'ri-eye-fill', label: 'Most Read', color: 'text-orange-400' },
            { icon: 'ri-star-fill', label: 'Top Rated', color: 'text-yellow-500' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-sm font-['Crimson_Text']">
              <div className={`w-5 h-5 flex items-center justify-center ${item.color}`}>
                <i className={item.icon} />
              </div>
              <span className="text-gray-300">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes float {
          from { transform: translateY(0px) scale(1); opacity: 0.4; }
          to   { transform: translateY(-12px) scale(1.5); opacity: 0.8; }
        }
      `}</style>
    </section>
  );
};

export default TopRankedHero;
